import styles from './FailureView.module.css';
import { Button } from '#/components/Button';
import { LINKS } from '#/constants';

const ERROR_IMAGE = `${import.meta.env.VITE_ASSETS_URL}/assets/images/invalid_link.png`;
const OPEN_IN_NEW_ICON = `${import.meta.env.VITE_ASSETS_URL}/assets/images/open_in_new.svg`;

type Props = {
  loginEmail: string | null;
  onRetry: () => void;
};

export function FailureView({ loginEmail, onRetry }: Props) {
  return (
    <div className={styles.card}>
      <img className={styles.image} src={ERROR_IMAGE} alt="" />
      <h1 className={styles.title}>生徒用アカウントの確認ができませんでした</h1>
      {/* 暫定文言。学園との合意が取れ次第差し替える。 */}
      <p className={styles.reason}>
        このZEN IDは、N高グループの生徒用アカウントとして登録されていません。正しいアカウントでログインしているかご確認ください。
      </p>
      {loginEmail && (
        <div className={styles.field}>
          <span className={styles.fieldLabel}>ログインに利用されたメールアドレス</span>
          <span className={styles.fieldValue}>{loginEmail}</span>
        </div>
      )}
      <Button variant="primary" onClick={onRetry}>
        もう一度ログインを試す
      </Button>
      <a className={styles.trouble} href={LINKS.technicalSupport} target="_blank" rel="noopener noreferrer">
        ログインでお困りの方はこちら
        <img className={styles.troubleIcon} src={OPEN_IN_NEW_ICON} alt="" />
      </a>
      <p className={styles.troubleSub}>（N高グループ テクニカルサポートサイト）</p>
    </div>
  );
}
